'use client';

import { useCallback, useEffect, useRef } from 'react';

const CHECK_INTERVAL = 30_000;

export function useUpdateChecker(onUpdate?: () => void) {
  const hasNotified = useRef(false);
  const baseVersion = useRef<string | null>(null);

  const check = useCallback(async () => {
    if (hasNotified.current) return;
    try {
      const res = await fetch('/api/version', { cache: 'no-store' });
      const { version } = await res.json();
      if (!version || version === 'unknown') return;

      if (!baseVersion.current) {
        // 首次请求，记录当前版本
        baseVersion.current = version;
        return;
      }

      if (version !== baseVersion.current) {
        hasNotified.current = true;
        onUpdate?.();
      }
    } catch {
      // 静默失败
    }
  }, [onUpdate]);

  useEffect(() => {
    // 挂载时立即获取基准版本
    check();

    const id = setInterval(check, CHECK_INTERVAL);

    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [check]);
}
